// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import "babel-polyfill"
import antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import components from '@/components'
// ueditor
import '../static/ueditor/ueditor.config.js'
import '../static/ueditor/ueditor.all.js'
import '../static/ueditor/lang/zh-cn/zh-cn.js'
import '../static/ueditor/ueditor.parse.js'
//charts
import VCharts from 'v-charts'
Vue.config.productionTip = false

Vue.use(VCharts)
Vue.use(antd)
Vue.use(components)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js